var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { staticClass: "mb-0" }, [
      _vm._v("\n        " + _vm._s(_vm.bonusDetails.subtitle) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-1" }, [
      _c(
        "div",
        { staticClass: "col-11 col-sm-10 col-md-8 col-lg-6" },
        [
          _c("p", { staticClass: "d-flex py-0 mb-0" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.first.item),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "ms-auto",
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.first.value),
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-100" }),
          _vm._v(" "),
          _c("p", { staticClass: "d-flex py-0 mb-0" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.second.item),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "ms-auto",
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.second.value),
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-100" }),
          _vm._v(" "),
          _c("ob1-separateur", { staticClass: "my-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "w-100" }),
          _vm._v(" "),
          _c("p", { staticClass: "d-flex py-0 mb-0" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.third.item),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "mt-auto ms-auto",
              domProps: {
                innerHTML: _vm._s(_vm.bonusDetails.example.third.value),
              },
            }),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-mw" }, [
      _c("p", {
        staticClass: "mb-0",
        domProps: { innerHTML: _vm._s(_vm.bonusDetails.modelMention) },
      }),
      _vm._v(" "),
      _vm.condition
        ? _c("p", {
            staticClass: "mb-0",
            domProps: { innerHTML: _vm._s(_vm.condition) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }